type Props = {
  className?: string;
};

export default function Selfie({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_7323_9667)">
        <path
          d="M23.0387 25H8.0387"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0387 6H21.2547C22.0012 6.01471 22.7118 6.32278 23.2329 6.85754C23.7539 7.3923 24.0434 8.11073 24.0387 8.85733V19.936"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9746 28.6187C23.8686 29.2698 23.5391 29.8637 23.0427 30.2983C22.5464 30.7329 21.9141 30.981 21.2546 31H10.8C10.0543 30.9877 9.34395 30.6798 8.82516 30.1441C8.30636 29.6083 8.02154 28.8884 8.03331 28.1427V16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.0387 6H3.0387"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0387 6H9.0387"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.0387 9V11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.0387 1V3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.9787 30.9988L24.032 28.6668C23.6771 28.4234 23.3965 28.0866 23.2212 27.6936C23.0458 27.3006 22.9827 26.8668 23.0387 26.4401V24.0001L21.6347 22.5254C21.4496 22.3407 21.3077 22.1171 21.2194 21.8709C21.1311 21.6247 21.0986 21.362 21.1241 21.1017C21.1496 20.8414 21.2325 20.59 21.3669 20.3656C21.5014 20.1412 21.6839 19.9494 21.9013 19.8041C22.2415 19.5778 22.6496 19.4761 23.0562 19.5165C23.4628 19.5568 23.8429 19.7366 24.132 20.0254L26.2133 22.1068"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0387 10.5879L28.9214 17.4359C29.648 18.4533 30.0386 19.6723 30.0387 20.9226V23.8252C30.0388 24.6604 30.3707 25.4614 30.9614 26.0519"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.616 14.5C12.616 15.4283 12.9848 16.3185 13.6412 16.9749C14.2975 17.6313 15.1878 18 16.116 18C17.0443 18 17.9345 17.6313 18.5909 16.9749C19.2473 16.3185 19.616 15.4283 19.616 14.5C19.616 13.5717 19.2473 12.6815 18.5909 12.0251C17.9345 11.3687 17.0443 11 16.116 11C15.1878 11 14.2975 11.3687 13.6412 12.0251C12.9848 12.6815 12.616 13.5717 12.616 14.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0387 25H10.116C10.116 23.4087 10.7482 21.8826 11.8734 20.7574C12.9986 19.6321 14.5247 19 16.116 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7323_9667">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
